import { useState } from 'react';
import { ImageOff } from 'lucide-react';

/**
 * An <img> that degrades to a neutral placeholder instead of a broken-image
 * icon and sprawling alt text. Listing photos come from host uploads, so a
 * dead URL is a normal condition, not an exceptional one.
 */
export default function Photo({ src, alt, className = '', ...rest }) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div className={`grid place-items-center bg-slate-200 text-slate-400 ${className}`} role="img" aria-label={alt}>
        <ImageOff className="h-5 w-5" aria-hidden="true" />
      </div>
    );
  }

  return (
    <img src={src} alt={alt} onError={() => setFailed(true)} className={className} {...rest} />
  );
}
